 
const React = require('react')
const PropTypes = require('prop-types')
const sanitize = require('lib/html/sanitize_bio')
const log = require('log').create('profile', 'bio') // eslint-disable-line

class Bio extends React.Component {

    getClassnames() {
        const classNames = [
            'bio',
            'inset',
        ]

        // The commented methods in this class (checkLength and countLines)
        // perform an actual DOM measurement using height and line-height. But
        // those methods don't run in the server-rendered version. If we only do
        // it in the client, the bio layout shifts when the short-bio class is
        // added. To avoid that, I'm simplifying this method to just check the
        // character length of the bio. This solution is isomorphic.
        if (this.props.user.bio.length < 120) classNames.push('short-bio')

        return classNames.join(' ')
    }

    render() {

        // const _ = require('lib/underscore')
        // const examples = [
        //     'condense_whitespace',
        //     'convert_div_to_p',
        //     'empty_paragraph',
        //     'empty_string',
        //     'enforce_maxlength',
        //     'enforce_maxlength_2',
        //     'ensure_outer_paragraph',
        //     'html5_br',
        //     'multiple_breaks_to_p',
        //     'neutered_tags',
        //     'normalize_markup',
        //     'paragraph_with_just_br',
        //     'remove_breaks',
        //     'remove_empty_blocks',
        //     'remove_nbsp',
        //     'strip_attributes',
        //     'strip_newlines',
        //     'target_blank',
        //     'trim_output',
        //     'unwrap_disallowed_tags',
        // ]
        // const names = [
        //     'annamaria',
        //     'antonioneves',
        //     'bfeld',
        //     'billtai',
        //     'brookehammerling',
        //     'cat',
        //     'cmichel',
        //     'cory',
        //     'daisyfan',
        //     'david',
        //     'dickcostolo',
        //     'dtrinh',
        //     'elianaa',
        //     'emilylafave',
        //     'garyvee',
        //     'hiten',
        //     'ianhannula',
        //     'jacobhartog',
        //     'james',
        //     'jamesj',
        //     'jayzombie',
        //     'jeffhodsdon',
        //     'jessejacobs',
        //     'jmreicha',
        //     'joncallahan',
        //     'jordandodds',
        //     'jyri',
        //     'kevinrose',
        //     'kzoeb',
        //     'liamcasey',
        //     'lindsaycampbell',
        //     'loic',
        //     'marquez',
        //     'mason',
        //     'matt',
        //     'melody',
        //     'mousumi',
        //     'nathan',
        //     'nickfogler',
        //     'nicolelapin',
        //     'om',
        //     'parisrouzati',
        //     'pcosgrave',
        //     'philblack',
        //     'rkulla',
        //     'ryanblock',
        //     'ryanchris',
        //     'sacca',
        //     'shawncollins',
        //     'shervinpishevar',
        //     'sierrabrown',
        //     'tconrad',
        //     'timferriss',
        //     'tonyconrad',
        //     'tonyhawk',
        //     'veen',
        //     'veronica',
        //     'wendyramos',
        // ]
        // const key = _.sample(examples)
        // const text = require(`../../../../test/tests/lib/html_tokenizer/snippets/${key}.source.txt`)
        // log('key', key)
        // log('text', text)
        // const bio = sanitize(text)
        // log('bio', bio)

        const bio = sanitize(this.props.user.bio)

        if (! bio) {
            return false
        }

        const html = {
            __html: bio,
        }

        return (
            <section className={this.getClassnames()}>
                <div dangerouslySetInnerHTML={html} />
            </section>
        )
    }

}

Bio.propTypes = {
    user: PropTypes.shape({
        bio: PropTypes.string,
    }).isRequired,
}


module.exports = Bio

// componentDidMount: function() {
//     this.checkLength()
// },
//
// componentDidUpdate: function() {
//     this.checkLength()
// },
//
// checkLength: function() {
//     // checks to see if the bio is really short
//     // if so, sets a 'short-bio' class which is used to modify the display
//     // e.g. centered on small/medium templates, or large mobile template
//     var short = false
//     var lines = this.countLines()
//     if (lines < 4) {
//         short = true
//     }
//     if (this.state.short !== short) {
//         console.log('lines', lines)
//         console.log('short', short)
//         this.setState({
//             short: short,
//         })
//     }
// },
//
// countLines: function() {
//     var ReactDOM = require('react-dom')
//     var el = ReactDOM.findDOMNode(this)
//     var line_height = parseFloat(getComputedStyle(el)['line-height'])
//     // console.log('line_height', line_height)
//     var height = el.offsetHeight
//     // console.log('height', height)
//     var lines = height / line_height
//     return lines
// },
